import { PropsWithChildren, useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Collapse,
  IconButton,
} from "@mui/material";
import { IconChevronUp, IconChevronDown } from "@tabler/icons-react";

type Props = {
  titulo: string;
  collapsable?: boolean;
  padding?: number;
};

export default function Secao(props: PropsWithChildren<Props>) {
  const [open, setOpen] = useState(true);

  return (
    <Card>
      <CardHeader
        // Section header do sistema: rótulo mono tracked sobre uma hairline que
        // atravessa — não uma barra sólida de tinta (DESIGN.md → Elevation).
        sx={(theme) => ({
          "&.MuiCardHeader-root": {
            backgroundColor: "transparent",
            borderBottom: `1px solid ${theme.palette.divider}`,
            paddingBlock: theme.spacing(1.5),
          },
          "& .MuiCardHeader-title": {
            ...theme.typography.labelMono,
            color: theme.palette.text.secondary,
          },
        })}
        title={props.titulo}
        action={
          props.collapsable && (
            <IconButton
              color="inherit"
              onClick={() => {
                props.collapsable && setOpen(!open);
              }}
              size="small"
            >
              {open ? <IconChevronUp /> : <IconChevronDown />}
            </IconButton>
          )
        }
      />
      <Collapse in={open} timeout="auto" unmountOnExit>
        <CardContent sx={{ p: props.padding ?? 2 }}>
          {props.children}
        </CardContent>
        <CardActions sx={{ p: 0 }}></CardActions>
      </Collapse>
    </Card>
  );
}
